import * as Mod1 from "./initializers/discourse-perspective";
const compatModules = {
  "initializers/discourse-perspective": Mod1,
};
export { compatModules };
export default compatModules;
